module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage table8"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-8：人员基本情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.excelModeUrl,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载模板")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "excelRead",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.ExHandle
    }
  }, [_vm._v("导入Excel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('ExcelIn', {
    ref: "ExcelSet",
    attrs: {
      "pressType": _vm.pressType,
      "excelCode": "208"
    },
    on: {
      "t-frash": _vm.goFresh,
      "excel-errors": _vm.errorCtrls
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.seekPms.type),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "type", $$v)
      },
      expression: "seekPms.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "通过姓名，身份证号（军官证号），手机号查询",
      "size": "small"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.memberDet(1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.memberClean
    }
  }, [_vm._v("清除全部")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n      注：1、持有岗位培训合格证书、持有出版专业职业资格证书，需要上传对应证书图片才能提交到上级，点击“编辑”按钮可以上传对应图片。\n      "), _c('br'), _vm._v(" "), _vm._v("\n      2、请在编辑人员中填写"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像业务")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子业务")]) : _vm._e(), _vm._v("全部编辑人员。\n      "), _c('br'), _vm._v(" "), _vm._v("\n      3、编辑人员表中不能重复填写负责人信息。\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize),
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + (_vm.currentPage - 1) * _vm.pageSize) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "姓名",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.gender, "C017", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号（军官证号）",
      "width": "270",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "job",
      "label": "职务",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.job, "C022", _vm.dicMap, scope.row)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政治面貌",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.politicalStatus, "C006", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文化程度",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.culture, "C005", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称系列",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.professionalTitleSeries, "C007", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称级别",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.titleLevel, "C008", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入职时间",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.rzDate, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "离职时间",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.lzDate, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "取得证书时间",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.trainCertificateDate, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否持有岗位培训资格证书",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type != 3) ? _c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.trainCertificateId)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.isTrainCertificate, "C018", _vm.dicMap)) + "\n            "), (scope.row.trainCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "持有出版专业职业资格证书情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.professionalCertificateId)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.certificateSituation, "C009", _vm.dicMap)) + "\n            "), (scope.row.professionalCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "background": "",
      "layout": "total, prev, pager, next",
      "total": _vm.tabDat.length,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.sizesArray
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.postDeclareFun
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pageArea"
  }), _vm._v(" "), _c('ExError', {
    ref: "chinldError",
    attrs: {
      "errorList": _vm.excelEr,
      "pressCode": "208"
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "pressComDiag",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": function($event) {
        _vm.urlCreate('close')
      }
    }
  }, [_c('div', {
    staticClass: "imgCont"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgShowUrl,
      "alt": ""
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3580b5be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/forTabs/table8.vue
// module id = 1706
// module chunks = 1